import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';
import { useConfig } from 'Context/ConfigContext';
import { getClassroomProviderData } from 'Util/classroomProviderUtils';
import useSidebarMenu from 'Util/Hooks/useSidebarMenu';
import useGetDeviceInfo from 'Util/Hooks/useGetDeviceInfo';

import SidebarWithIcon from './SidebarWithIcon';
import SidebarFlat from './SidebarFlat';

const SideMenu = ({ image, name, displayName, isLogin, providerName, menuItems, t, ...props }) => {
  const { Sidebar: SidebarStyle } = getAppUIVariantConfig();
  const { isOpenExtLink, appVersion, myCourses, uiVariant } = useConfig();

  const { appVersion: deviceAppVersion } = useGetDeviceInfo();
  const menuList = useSidebarMenu();

  // FIXME: For workaround appVersion from Capacitor when contextIsolation is true
  const [electronAppVersion, setElectronAppVersion] = useState(null);
  const isElectron = !!window.electron?.isElectron;

  useEffect(() => {
    let isMounted = true;

    if (isElectron) {
      window.electron.getAppVersion().then((version) => {
        if (isMounted) {
          setElectronAppVersion(version);
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [isElectron]);

  const currentVersion = isElectron ? electronAppVersion : deviceAppVersion;
  const appVersionInfo = currentVersion || appVersion;

  const sidebarConfig = myCourses?.sidebar ?? {};
  const { phoneNo: workPhoneNumber, workTime } = sidebarConfig;

  const sidebarMenus = uiVariant !== 'PAAS' ? menuItems : menuList;

  const classroomProviderData = getClassroomProviderData(providerName);
  const { logoPath, title, phoneNo, phoneHref } = classroomProviderData ?? {};

  switch (SidebarStyle) {
    case 'WithIcon': {
      return (
        <SidebarWithIcon
          displayName={displayName}
          appVersion={appVersionInfo}
          imageProfileUrl={image}
          phoneNo={workPhoneNumber}
          workTime={workTime}
          menuItems={sidebarMenus}
          {...props}
        />
      );
    }
    case 'Flat':
    default: {
      return (
        <SidebarFlat
          name={name}
          logoPath={logoPath}
          title={title}
          phoneNo={phoneNo}
          phoneHref={phoneHref}
          appVersion={appVersionInfo}
          isLogin={isLogin}
          providerName={providerName}
          isOpenExtLink={isOpenExtLink}
          menuItems={sidebarMenus}
          {...props}
        />
      );
    }
  }
};

SideMenu.propTypes = {
  name: PropTypes.string,
  isLogin: PropTypes.bool,
};

export default withTranslation('menu')(SideMenu);
